"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var platformCardApi = _interopRequireWildcard(require("@/api/platformCardApi.js"));
var storeApi = _interopRequireWildcard(require("@/api/store"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _editCard = _interopRequireDefault(require("./editCard.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditCard: _editCard.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      merCateList: [],
      productLists: [],
      orderStateOption: [{
        value: 1,
        label: '入库'
      }, {
        value: 2,
        label: '使用'
      }, {
        value: 0,
        label: '作废'
      }],
      skuId: null,
      productName: '',
      importDialogVisible: false,
      importFileName: '',
      importFileRaw: null,
      importSubmitLoading: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.skuId = id;
    this.productName = this.$route.query.productName || '';
    this.searchProduct('');
    this.getCategorySelect();
    this.handlerGetListData(this.listPram);
  },
  methods: {
    throttle: _throttle.default,
    handerSearch: function handerSearch() {
      if (!this.listPram.skuId) {
        this.searchProduct('');
      }
      ;
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      platformCardApi.kamiDetailLists(_objectSpread(_objectSpread({}, pram), {}, {
        skuId: this.skuId
      })).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs['EditCardRef'].openInit(row);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      storeApi.categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this2.merCateList = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    removeKami: function removeKami(ids) {
      var _this3 = this;
      this.$confirm('确认作废该条卡密？', '确认作废', {
        type: 'warning'
      }).then(function (result) {
        platformCardApi.removeKami({
          ids: ids
        }).then(function (res) {
          _this3.$message.success('操作成功');
          _this3.handerSearch();
        });
      });
    },
    openImportDialog: function openImportDialog() {
      this.importDialogVisible = true;
    },
    resetImportDialog: function resetImportDialog() {
      var _this4 = this;
      this.importFileName = '';
      this.importFileRaw = null;
      this.importSubmitLoading = false;
      this.$nextTick(function () {
        if (_this4.$refs.importUpload) _this4.$refs.importUpload.clearFiles();
      });
    },
    handleDownloadTemplate: function () {
      var _handleDownloadTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return platformCardApi.downloadCarmineImportTemplate();
            case 1:
              res = _context.v;
              window.open(res.fileName, '_blank');
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error('下载模板失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function handleDownloadTemplate() {
        return _handleDownloadTemplate.apply(this, arguments);
      }
      return handleDownloadTemplate;
    }(),
    handleImportFileChange: function handleImportFileChange(file) {
      var raw = file && file.raw;
      if (!raw) return;
      var ext = (raw.name || '').split('.').pop().toLowerCase();
      if (!['xls', 'xlsx'].includes(ext)) {
        this.$message.warning('仅支持 .xls / .xlsx 文件');
        this.handleRemoveImportFile();
        return;
      }
      this.importFileRaw = raw;
      this.importFileName = raw.name;
    },
    handleRemoveImportFile: function handleRemoveImportFile() {
      var _this5 = this;
      this.importFileName = '';
      this.importFileRaw = null;
      this.$nextTick(function () {
        if (_this5.$refs.importUpload) _this5.$refs.importUpload.clearFiles();
      });
    },
    handleConfirmImport: function () {
      var _handleConfirmImport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var formData;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.importFileRaw) {
                _context2.n = 1;
                break;
              }
              this.$message.warning('请先选择导入文件');
              return _context2.a(2);
            case 1:
              formData = new FormData();
              formData.append('file', this.importFileRaw);
              this.importSubmitLoading = true;
              _context2.p = 2;
              _context2.n = 3;
              return platformCardApi.importBindCard(formData, this.skuId);
            case 3:
              this.$message.success('导入成功！');
              this.importDialogVisible = false;
              this.handerSearch();
            case 4:
              _context2.p = 4;
              this.importSubmitLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2,, 4, 5]]);
      }));
      function handleConfirmImport() {
        return _handleConfirmImport.apply(this, arguments);
      }
      return handleConfirmImport;
    }(),
    searchProduct: function searchProduct() {
      var _this6 = this;
      var skuName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.productLists = [];
      platformCardApi.getProductSkuList({
        type: 0,
        productType: 12,
        page: 1,
        limit: 50,
        skuName: skuName
      }).then(function (res) {
        _this6.productLists = (res === null || res === void 0 ? void 0 : res.list) || [];
      });
    },
    handleProductSearch: function handleProductSearch(data) {
      var _this7 = this;
      this.throttle(function () {
        _this7.searchProduct(data);
      }, 300)();
    }
  }
};